import { SVGFC } from '@repo/toolkit/types'

const ArrowUpTwoIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_15088_168770)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.49975 12.0001C8.49975 11.6779 8.76092 11.4167 9.08309 11.4167H17.0084L15.6709 10.0792C15.4431 9.85142 15.4431 9.48208 15.6709 9.25427C15.8986 9.02646 16.268 9.02646 16.4958 9.25427L18.8291 11.5876C18.9385 11.697 19 11.8454 19 12.0001C19 12.1548 18.9385 12.3032 18.8291 12.4126L16.4958 14.7459C16.268 14.9737 15.8986 14.9737 15.6709 14.7459C15.4431 14.5181 15.4431 14.1487 15.6709 13.9209L17.0084 12.5834H9.08309C8.76092 12.5834 8.49975 12.3223 8.49975 12.0001ZM5.58333 6.16675C5.9055 6.16675 6.16667 6.42792 6.16667 6.75008V17.2501C6.16667 17.5723 5.9055 17.8334 5.58333 17.8334C5.26117 17.8334 5 17.5723 5 17.2501L5 6.75008C5 6.42792 5.26117 6.16675 5.58333 6.16675Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_15088_168770">
          <rect width="14" height="14" fill="white" transform="matrix(0 1 1 0 5 5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ArrowUpTwoIcon
